import { constants as config, headerAndFooter } from '@config';
import { getMimeTypeFromDataUrl } from 'assets/js/helpers/dataUrl';

function PopupMenuDefault (element, options) {
  this.$element = $(element);
  this.id = INKIVE.Math.generateUUID();

  const selectedItems = INKIVE.EditorFacade.canvas.getSelectedElems();
  if (selectedItems.length < 2) {
    this.buttons = INKIVE.RestrictionsFacade.filterMenuOptions(element, options.buttons || []);
  } else {
    let buttonsCount = Number.MAX_SAFE_INTEGER;
    for (let i = 0; i < selectedItems.length; i++) {
      const buttonList = INKIVE.RestrictionsFacade.filterMenuOptions(selectedItems[i], options.buttons || []);
      if (buttonList?.length && buttonList.length < buttonsCount) {
        this.buttons = buttonList;
        buttonsCount = this.buttons.length;
      }
    }
  }

  if (typeof INKIVE.PopupMenuDefault.canAccessLibrary === 'undefined') {
    INKIVE.PopupMenuDefault.canAccessLibrary = true;
    if (INKIVE.Helpers.isDesygnerProject()) {
      INKIVE.PopupMenuDefault.canAccessLibrary = null;
      INKIVE.UserInfoFactory.get().then(_.bind(function (userInfo) {
        INKIVE.PopupMenuDefault.canAccessLibrary =
          _(userInfo.roles).contains('ROLE_LIBRARY') ||
          _(userInfo.roles).contains('ROLE_PREMIUM');
      }, this));
    }
  }

  if (typeof INKIVE.PopupMenuDefault.canAccessWorkspaceLibrary === 'undefined') {
    INKIVE.PopupMenuDefault.canAccessWorkspaceLibrary = false;

    INKIVE.UserInfoFactory.getMembership().then(function (userInfo) {
      INKIVE.PopupMenuDefault.canAccessWorkspaceLibrary = userInfo.permissions.assets_manage;
    });
  }

  const parentButtons = [];
  _.each(this.buttons, _.bind(function (action) {
    if (INKIVE.PopupMenuDefault.Buttons[action]) {
      const isSubmenuOf = INKIVE.PopupMenuDefault.Buttons[action].isSubmenuOf;
      isSubmenuOf && parentButtons.push(_.findKey(INKIVE.PopupMenuDefault.Buttons, { action: isSubmenuOf }));
    }
  }, this));

  this.buttons = parentButtons.reduce((acc, value) => {
    if (acc.includes(value)) return acc;
    return [value, ...acc];
  }, this.buttons);

  INKIVE.RestrictionsFacade.elementHasRestrictions(element) && this.buttons.push('RESTRICTION_INFO');

  if ($(element).is('.non-selectable')) {
    this.buttons = ['REMOVE'];
  }

  this.hideTextColumnButtons();
  _.each(this.buttons, this.append, this);

  this.isReady = false;
  options.disableBuild || this.build();
}

PopupMenuDefault.prototype = {
  positions: {},
  constructor: INKIVE.PopupMenuDefault,

  build: function () {
    if (!this.buttons?.length) {
      INKIVE.Menus.elementPopupMenu.hide();
      return;
    }

    const that = this;

    const $menu = that.menu();
    const MIN_MOREMENU = 5;
    const additionalMenuItems = $menu.find('li[data-additional-menu="true"]');
    if (additionalMenuItems.length) {
      if (additionalMenuItems.length > MIN_MOREMENU) {
        $menu.find('li.space').replaceWith(INKIVE.TemplatesHelper('popupmenu_additional'));
        that.append(INKIVE.TemplatesHelper('popupmenu_showmore'));
      } else {
        additionalMenuItems.removeAttr('data-additional-menu').show();
      }
    }

    this.$element.is('#svgroot') || this.isMenuValid() || INKIVE.Menus.elementPopupMenu.hide();

    $menu.find('[data-action="on_show_more"]').on('click', function () {
      $menu.find('li[data-additional-menu="true"]').show();
      $(this).hide();
    });

    // remove duplicates
    let isSpace = false;
    $menu.find('>li').each(function () {
      if ($(this).hasClass('space')) {
        isSpace && $(this).remove();
        isSpace = true;
      } else {
        isSpace = false;
      }
    });

    INKIVE.Helpers.initTooltips($menu, { placement: 'top' });

    this.isReady = true;
  },

  isAllSelectedElementsLocked: function () {
    const allSelectedElements = INKIVE.EditorFacade.canvas.getSelectedElems();
    return allSelectedElements.length && allSelectedElements.every(element => element?.classList?.contains('locked'));
  },

  buttonHtml: function (buttonName, opts) {
    if (!buttonName) return;
    if (buttonName === ' ') {
      return this.getSpacer();
    }

    const b = _.clone(INKIVE.PopupMenuDefault.Buttons[buttonName]);

    if (b && b.toggle) {
      const data = INKIVE.DesignFacade.get(this.$element.attr('id'));
      b.isApplied = _.isFunction(b.toggle) ? b.toggle(data) : data[b.toggle];

      if (!b.isApplied) {
        buttonName = 'off_' + buttonName;
      }
    }

    const menuItem = translate($.extend({}, b, opts), buttonName);

    const isLocked = this.isAllSelectedElementsLocked();
    const isLinked = $(this.$element).closest('a').length > 0;
    const isLayoutBox = this.$element.hasClass('layoutBox');
    const isBackground = this.$element.parent().is('.background');
    const hasLink = !this.$element.attr('xlink:href') ||
      (this.$element.attr('xlink:href').indexOf('imageplaceholder') >= 0);

    if ((menuItem.hide && menuItem.hide(this.$element)) || // custom hide method
      (menuItem.forMobile && !INKIVE.C.IS_MOBILE) ||
      (menuItem.forBoxImage && !isLayoutBox) ||
      (menuItem.forBoxWithImage && isLayoutBox && hasLink && !isBackground) ||
      (menuItem.notSubelement && this.$element.hasClass('subelement')) || // Subelement check
      (menuItem.notLocked && isLocked) || // Locked check
      (menuItem.isLocked && !isLocked) || // Unlocked check
      (menuItem.notLinked && isLinked) || // Link check
      (menuItem.isLinked && !isLinked) // Unlink check
    ) {
      return;
    }

    let btnCls = 'btn btn-onmenu action';
    if (menuItem.disabled) btnCls += ' disabled';
    if (menuItem.isApplied === true) btnCls += ' turned-on';
    if (menuItem.isDropdown) btnCls += ' ui-dropdown';

    const dataAction = ' data-action="' + menuItem.action + '"';
    const dataShortcut = menuItem?.shortcut ? ` data-shortcut="${menuItem?.shortcut}"` : '';

    const tooltipContent = _.isFunction(menuItem.tooltip)
      ? menuItem.tooltip()
      : menuItem.tooltip || menuItem.dropdownTitle;

    const tooltip = tooltipContent ? ' data-popover="tooltip" data-original-title="' + tooltipContent + '"' : '';
    const tooltipTitled = tooltipContent ? ' data-popover="tooltip-titled-buttons" data-original-title="' + tooltipContent + '"' : '';

    const dataType = menuItem.type ? ' type="' + menuItem.type + '"' : '';

    const dataTitle = ' data-title="' + (menuItem.title ? menuItem.title : (tooltipContent || '')) + '"';

    const bWrapper = this.getButtonWrapper(menuItem);

    if (menuItem.cls) {
      $(bWrapper).addClass(menuItem.cls);
    }

    let icon = menuItem.icon ? '<i class="' + menuItem.icon + '"></i>' : '';

    if (menuItem.isApplied === false) {
      icon = '<i class="' + menuItem.icon + '"></i><span class="deny"></span>';

      // tooltip = tooltipContent ? ' data-popover="tooltip" data-original-title="' + tooltipContent + '"' : '';
      // dataType = menuItem.type ? ' type="' + menuItem.type + '"' : '';
      // dataTitle = ' data-title="' + ( menuItem.title ? menuItem.title : tooltipContent ? tooltipContent : '' ) + '"';
    }

    if (menuItem.iconSvg) {
      icon = '<icon><svg><use xlink:href="#' + menuItem.iconSvg + '"></use></svg></icon>';
    }

    function verifyDropdownTitle () {
      if (menuItem.hasDropdownTitle === true) {
        return $('<a class="' + btnCls + '"' + dataAction + tooltipTitled + dataType + dataTitle + dataShortcut + '>' + icon + '</a>');
      } else {
        return $('<a class="' + btnCls + '"' + dataAction + tooltip + dataType + dataTitle + dataShortcut + '>' + icon + '</a>');
      }
    }

    const $menu = verifyDropdownTitle();

    menuItem.titleTag && $menu
      .prepend('<span class="ui-dropdown-tag-title">' + (menuItem.dropdownTitle || '') + '</span>');

    if (menuItem.isDropdown) {
      let dropdownStyle = '';
      if (menuItem.dropdownWidth) {
        dropdownStyle += ' width: ' + menuItem.dropdownWidth + ';';
      }
      if (menuItem.dropdownHeight) {
        dropdownStyle += ' height: ' + menuItem.dropdownHeight + ';';
      }

      let dropdownCls = 'ui-dropdown-items';
      if (menuItem.fullscreenDropdown) {
        dropdownCls += ' fullscreen';
      }
      if (menuItem.modalDropdown) {
        dropdownCls += ' ui-dropdown-modal';
      }

      if (menuItem.isHorizontal) {
        dropdownCls += ' horizontal';
      } else if (!menuItem.isDropdownList) {
        dropdownCls += ' ui-dropdown-div';
      }

      if (menuItem.isDropdownList) {
        dropdownCls += ' ui-dropdown-list';
      }

      menuItem.hasDropdownTitle && $menu.append(
        '<span class="ui-dropdown-title">' + (menuItem.dropdownTitle || '') + '</span>');

      let $dropdownDiv = $('<div class="' + dropdownCls + '" style="' + dropdownStyle + '"></div>');
      menuItem.isMultipleDropdown && $dropdownDiv.addClass('dropdown-multiple');
      $menu.append($dropdownDiv);

      if (menuItem.dropdownDisplay) {
        $dropdownDiv[0].dataset.display = menuItem.dropdownDisplay;
      }

      if (menuItem.dropdownContent) {
        if (_.isFunction(menuItem.dropdownContent)) {
          menuItem.dropdownContent($dropdownDiv);
        } else {
          const $ul = $('<ul/>');

          _.each(menuItem.dropdownContent, _.bind(function (data, key) {
            $ul.append(this.buttonHtml(key, data));
          }, this));

          if (menuItem.isSubmenuOf) {
            const $parent = $('[data-action=' + menuItem.isSubmenuOf + ']');
            const hideTitle = menuItem.hideTitle && menuItem.hideTitle();
            const title = hideTitle
              ? ''
              : (INKIVE.TranslateHelper.translate('popupmenu.dropdown_title.' + menuItem.dropdownTitle) || '');
            $dropdownDiv = $parent.find('.ui-dropdown-items');
            !hideTitle && menuItem.dropdownTitle && $dropdownDiv.append('<div class="ui-dropdown-content-title ' + menuItem.action + '">' + title +
            '</div>');
          }
          $dropdownDiv.append($ul);
        }
      }

      if (menuItem.dropdownOptions) {
        const $dropdownContainer = $('<div class="dropdown-options">');
        const $select = $('<select>');
        const dropdownTranslate = function (key) {
          return INKIVE.TranslateHelper.translate('popupmenu.dropdown_options.' + buttonName.toLowerCase() + '.' + key);
        };

        $dropdownContainer.append('<span>' + dropdownTranslate('title') + '</span>');
        _.each(menuItem.dropdownOptions.options, function (option) {
          $select.append('<option value="' + option + '">' + dropdownTranslate(option) + '</option>');
        });

        $dropdownContainer.append($select);
        $('.ui-dropdown-content-title.' + b.action).after($dropdownContainer);
      }
    }

    if (!menuItem.isSubmenuOf && menuItem.action) {
      return $(bWrapper).append($menu);
    }

    function translate (button, id) {
      id = id.toLowerCase();

      const t = INKIVE.TranslateHelper.translate;
      const key = 'popupmenu.';
      const translations = _.omit({
        title: t(key + 'title.' + id),
        tooltip: t(key + 'tooltip.' + id),
        dropdownTitle: t(key + 'dropdown_title.' + id)
      }, hasNoTranslation);

      return _.extend(translations, button);

      function hasNoTranslation (value, objKey) {
        objKey = objKey === 'dropdownTitle'
          ? key + 'dropdown_title.' + id
          : key + objKey + '.' + id;

        return objKey === value;
      }
    }
  },

  getSpacer: function () {
    return '<li class="space"></li>';
  },

  getButtonWrapper: function (menuItem) {
    const isAdditional = (menuItem.isAdditional) ? ' data-additional-menu="true" style="display: none;"' : '';
    return $.parseHTML('<li' + isAdditional + '></li>');
  },

  destroy: function () {
    this.$element.removeData('popupmenu');
  },

  getWrapperHtml: function () {
    return '<div class="menu popupmenu" data-id="' + this.id + '" ' +
      'data-element-id="' + this.$element.attr('id') + '"/>';
  },

  wrapper: function () {
    const selector = this.$element.is('#svgroot') ? '.root-popupmenu' : '.element-popupmenu';
    const popupmenuContainer = $('#element-popupmenu').find(selector);

    if (!popupmenuContainer.data('id') !== this.id) {
      popupmenuContainer.data('id', this.id);
      popupmenuContainer.data('element-id', this.$element.attr('id'));
    }

    return popupmenuContainer;
  },

  getButtonContainer: function (buttonData) {
    let buttonsContainer = '.specific-buttons';

    if (_.contains(INKIVE.Menus.elementPopupMenu.popupMenuButtons.defaultMenus.ROOT, buttonData)) {
      buttonsContainer = '.root-buttons';
    } else if (_.contains(INKIVE.Menus.elementPopupMenu.popupMenuButtons.defaultMenus.COMMON, buttonData)) {
      buttonsContainer = '.common-buttons';
    } else if (_.contains(INKIVE.Menus.elementPopupMenu.popupMenuButtons.defaultMenus.SPECIAL, buttonData)) {
      buttonsContainer = '.special-buttons';
    }

    return this.menu().parent(buttonsContainer).find('>ul');
  },

  append: function (data, opts) {
    const html = (data.startsWith && data.startsWith('<li')) ? data : this.buttonHtml(data, opts);

    html && this.getButtonContainer(data).append(html);
  },

  appendBeforeSelector: function (selector, data, opts) {
    const html = (data.startsWith && data.startsWith('<li')) ? data : this.buttonHtml(data, opts);

    html && this.getButtonContainer(data).find(selector).parent('li').before(html);
  },

  prepend: function (data, opts) {
    const html = (data.startsWith && data.startsWith('<li')) ? data : this.buttonHtml(data, opts);

    html && this.getButtonContainer(data).prepend(html);
  },

  menu: function () {
    const $wrapper = this.wrapper();
    return $wrapper.find('.special-buttons>ul, .specific-buttons>ul, .common-buttons>ul, .root-buttons>ul');
  },

  getShownMenuButtonsCount: function () {
    const $menu = this.menu();
    return $menu.find('li:not(.space)').length;
  },

  isMenuValid: function () {
    return this.getShownMenuButtonsCount() > 0;
  },

  button: function (action) {
    return this.menu().find('[data-action="' + action + '"]');
  },

  li: function (action) {
    return this.menu().find('[data-action="' + action + '"]').parent('li');
  },

  element: function () {
    return this.$element.get(0);
  },

  hideTextColumnButtons: function () {
    if (this.$element.is('.textarea')) {
      const textarea = new INKIVE.Text.Textarea().setDOM(this.$element[0]);

      if (textarea.text.columns > 1) {
        this.buttons = _.without(this.buttons, 'STROKE', 'STROKE_COLOR', 'HIGHLIGHT_COLOR', 'TEXT_AUTO_ADJUSTABLE');
      }
    }
  },

  isBackgroundImage: function (elem) {
    let $elem = $(elem);

    if ($elem.is('g')) {
      $elem = $elem.find('image');
    }

    return $elem.is('image');
  },

  isAddtoLibraryAvailable: function (shouldSupportConversion) {
    // Allow if only one object is selected
    const selectedItems = INKIVE.EditorFacade.canvas.getSelectedElems();
    if (!selectedItems || selectedItems.length !== 1) return false;

    const selectedItem = selectedItems[0];

    // Does user have the permissions?
    const isAddToLibraryAllowed = INKIVE.Menus.elementPopupMenu.popupMenuButtons.popupMenuCommonFunctions.isAddToLibraryAllowed(selectedItem);
    if (!isAddToLibraryAllowed) return false;

    if (typeof shouldSupportConversion === 'undefined') return true;

    // Decide by type
    const id = selectedItem.classList.contains('background') ? 'background' : selectedItem.getAttribute('id');
    const data = INKIVE.DesignFacade.get(id);
    if (!data) return false;

    const canBeConverted = ['sticker', 'group', 'icon', 'logo'].includes(data.type);

    return ((canBeConverted && shouldSupportConversion) ||
      (!canBeConverted && !shouldSupportConversion));
  }
};

PopupMenuDefault.Buttons = {
  // All
  INCREASE: {
    action: 'on_increaseElement',
    icon: 'desygner-icon-plus',
    notSubelement: true,
    forMobile: true,
    notLocked: true
  },
  DECREASE: {
    action: 'on_decreaseElement',
    icon: 'desygner-icon-minus',
    notSubelement: true,
    forMobile: true,
    notLocked: true
  },

  DUPLICATE: {
    action: 'on_copyElement',
    iconSvg: 'duplicate---20',
    notSubelement: true,
    cls: 'has-right-dividing-line'
  },
  REMOVE: {
    action: 'on_removeElement',
    iconSvg: 'trash---20',
    notSubelement: true
  },

  OPACITY: {
    action: 'on_opacity',
    icon: 'desygner-icon-opacity',
    isHorizontal: true,
    cls: 'opacity',
    isDropdown: true,
    dropdownWidth: '230px',
    notSubelement: true
  },
  STROKE: {
    action: 'on_stroke',
    iconSvg: 'menu-stroke',
    isDropdown: true,
    dropdownWidth: '240px',
    notSubelement: true,
    hide: function (elem) {
      let hide = false;
      if (elem.is('.sticker')) {
        hide = !elem.find('>path').length;
      }
      return hide;
    },
    cls: 'has-right-dividing-line'
  },

  TRANSFORM: {
    iconSvg: 'grid---20',
    action: 'on_transform',
    isHorizontal: true,
    isMultipleDropdown: true,
    cls: 'transform',
    notSubelement: true,
    isDropdown: true
  },

  ORDER: {
    action: 'on_order',
    iconSvg: 'layers---20',
    notSubelement: true,
    isDropdown: true,
    isHorizontal: true,
    isMultipleDropdown: true,
    dropdownContent: {
      SEND_FORWARD: {
        action: 'on_sendForward',
        iconSvg: 'put-out'
      },
      SEND_BACKWARD: {
        action: 'on_sendBackward',
        iconSvg: 'put-in'
      },
      SEND_TOP: {
        action: 'on_sendTop',
        iconSvg: 'normal'
      },
      SEND_BOTTOM: {
        action: 'on_sendBottom',
        iconSvg: 'upside-down'
      }
    }
  },

  ROTATE: {
    action: 'on_rotate',
    notSubelement: true,
    isDropdown: true,
    isHorizontal: true,
    isSubmenuOf: 'on_transform',
    dropdownContent: {
      ROTATE_LEFT: {
        action: 'on_rotateLeft',
        iconSvg: 'rotate-left',
        cls: 'quadra',
        notSubelement: true
      },
      ROTATE_RIGHT: {
        action: 'on_rotateRight',
        iconSvg: 'rotate-right',
        cls: 'quadra',
        notSubelement: true
      }
    }
  },

  FLIP: {
    action: 'on_flip',
    notSubelement: true,
    isDropdown: true,
    isHorizontal: true,
    isSubmenuOf: 'on_transform',
    dropdownContent: {
      FLIP_V: {
        action: 'on_flipV',
        iconSvg: 'flip-verticle',
        cls: 'quadra',
        notSubelement: true,
        hide: function (elem) {
          return INKIVE.Helpers.elementHelper(elem[0]).isQRCode();
        }
      },
      FLIP_H: {
        action: 'on_flipH',
        iconSvg: 'flip-horizontal',
        cls: 'quadra',
        notSubelement: true,
        hide: function (elem) {
          return INKIVE.Helpers.elementHelper(elem[0]).isQRCode();
        }
      }
    }
  },
  FLIP_IMAGE: {
    action: 'on_flip_image',
    notSubelement: true,
    isDropdown: true,
    isHorizontal: true,
    isSubmenuOf: 'on_transform',
    dropdownContent: {
      FLIP_IMAGE_H: {
        action: 'on_flipImageH',
        iconSvg: 'flip-horizontal',
        notSubelement: true,
        type: 'toggle'
      },
      FLIP_IMAGE_V: {
        action: 'on_flipImageV',
        iconSvg: 'flip-verticle',
        notSubelement: true,
        type: 'toggle'
      }
    }
  },
  BACKGROUND_FLIP: {
    action: 'on_flip_background',
    notSubelement: true,
    isDropdown: true,
    isSubmenuOf: 'on_transform',
    dropdownContent: {
      BACKGROUND_FLIP_H: {
        action: 'on_flipBackgroundH',
        iconSvg: 'flip-horizontal',
        notSubelement: true,
        type: 'toggle'
      },
      BACKGROUND_FLIP_V: {
        action: 'on_flipBackgroundV',
        iconSvg: 'flip-verticle',
        notSubelement: true,
        type: 'toggle'
      }
    }
  },

  ARRANGE: {
    iconSvg: 'align-horizontally---20',
    action: 'on_arrange',
    notSubelement: true,
    isMultipleDropdown: true,
    isDropdown: true,
    dropdownWidth: '324px',
    dropdownDisplay: 'flex',
    tooltip: () =>
      INKIVE.TranslateHelper.translate('popupmenu.dropdown_title.align_title')
  },

  ALIGNMENT: {
    action: 'on_alignment',
    notSubelement: true,
    isDropdown: true,
    isHorizontal: true,
    isSubmenuOf: 'on_arrange',
    hideTitle: () => (INKIVE.DesignFacade.canvas.getSelectedElems() || []).length < 2,
    dropdownWidth: '324px',
    dropdownTitle: 'alignment_title',
    dropdownContent: {
      ALIGN_HORIZONTAL_MIDDLE: {
        action: 'on_align-horizontal-middle',
        iconSvg: 'align-horizontally',
        shortcut: 'ALT+H'
      },
      ALIGN_VERTICAL_MIDDLE: {
        action: 'on_align-vertical-middle',
        iconSvg: 'align-vertically',
        shortcut: 'ALT+V'
      },
      ALIGN_LEFT: {
        action: 'on_align-left',
        iconSvg: 'align-left',
        shortcut: 'ALT+A'
      },
      ALIGN_RIGHT: {
        action: 'on_align-right',
        iconSvg: 'align-right',
        shortcut: 'ALT+D'
      },
      ALIGN_TOP: {
        action: 'on_align-top',
        iconSvg: 'align-top',
        shortcut: 'ALT+W'
      },
      ALIGN_BOTTOM: {
        action: 'on_align-bottom',
        iconSvg: 'align-bottom',
        shortcut: 'ALT+S'
      }
    }
  },

  DISTRIBUTE: {
    iconSvg: 'fit-width',
    action: 'on_distribution',
    notSubelement: true,
    isDropdown: true,
    isHorizontal: true,
    isSubmenuOf: 'on_arrange',
    hideTitle: () => (INKIVE.DesignFacade.canvas.getSelectedElems() || []).length < 2,
    dropdownWidth: '324px',
    dropdownTitle: 'distribute_title',
    dropdownContent: {
      DISTRIBUTE_HORIZONTAL: {
        action: 'on_distribute-horizontal',
        iconSvg: 'distribute-horizontal',
        shortcut: 'ALT+SHIFT+H',
        hide: () => (INKIVE.DesignFacade.canvas.getSelectedElems() || []).length < 2
      },
      DISTRIBUTE_VERTICAL: {
        action: 'on_distribute-vertical',
        iconSvg: 'distribute-vertical',
        shortcut: 'ALT+SHIFT+V',
        hide: () => (INKIVE.DesignFacade.canvas.getSelectedElems() || []).length < 2
      },
      TIDY: {
        action: 'on_tidy',
        iconSvg: 'elements---square',
        shortcut: 'ALT+CTRL+SHIFT+T',
        hide: () => (INKIVE.DesignFacade.canvas.getSelectedElems() || []).length < 2
      }
    },
    hide: () => (INKIVE.DesignFacade.canvas.getSelectedElems() || []).length < 2
  },
  // -----------------------------------------------------------------------------------------------------------------
  // Color
  FILL_COLOR: {
    action: 'colormap-circle',
    icon: 'desygner-icon-fill',
    cls: 'quadra',
    type: 'fill',
    isDropdown: true,
    dropdownWidth: '242px',
    hide: function (elem) {
      return INKIVE.Helpers.elementHelper(elem[0]).isQRCode() && !INKIVE.UserInfoFactory.isProUser();
    }
  },

  TEXT_FILL_COLOR: {
    action: 'colormap-circle',
    iconSvg: 'text-color---20',
    cls: 'quadra',
    type: 'fill',
    isDropdown: true,
    dropdownWidth: '242px'
  },
  HIGHLIGHT_COLOR: {
    action: 'colormap-circle',
    iconSvg: 'text-highlight---20',
    cls: 'quadra',
    type: 'highlight',
    isDropdown: true,
    dropdownWidth: '242px'
  },

  STROKE_COLOR: {
    action: 'colormap-circle',
    iconSvg: 'elipse---20',
    cls: 'quadra-stroke-color',
    type: 'stroke',
    isDropdown: true,
    dropdownWidth: '242px',
    notSubelement: true,
    hide: function (elem) {
      let hide = false;
      if (elem.is('.sticker')) {
        hide = !elem.find('>path').length;
      }
      return hide;
    }
  },

  // -----------------------------------------------------------------------------------------------------------------
  // Image
  IMAGE_REPOSITION: {
    action: 'on_reposition',
    icon: 'desygner-icon-reposition',
    hasDropdownTitle: true,
    cls: 'double',
    isDropdown: true,
    forBoxWithImage: true,
    hide: function (elem) {
      const element = elem.get(0);
      const elementDetails = INKIVE.Helpers.elementHelper(element);
      const image = elementDetails.isSticker()
        ? element.querySelector('image')
        : element;
      if (!image) return true;
      if (
        INKIVE.Helpers.elementHelper(element).isVideo() &&
        INKIVE.RestrictionsFacade.initialized &&
        !INKIVE.RestrictionsFacade.canChange(element, 'position')
      ) {
        return true;
      }
      const hasPlaceholder =
        (image.getAttribute('xlink:href') || '').indexOf('imageplaceholder') >
        -1;

      return !image.classList.contains('layoutBox') || hasPlaceholder;
    }
  },
  IMAGE_CROP: {
    action: 'on_crop',
    iconSvg: 'crop',
    cls: 'double',
    isDropdown: true,
    type: 'toggle',
    forBoxWithImage: true,
    hide: function (elem) {
      return $(elem).hasClass('layoutBox');
    }
  },

  IMAGE_BOX: {
    action: 'on_imageBox',
    icon: 'desygner-icon-image',
    cls: 'double has-left-dividing-line',
    isDropdown: true,
    hasDropdownTitle: true,
    iconSvg: 'convert-image---20',
    hide: function (elem) {
      return INKIVE.PopupMenuDefault.prototype.isBackgroundImage(elem);
    }
  },
  IMAGE_TAB: {
    action: 'on_imageTab',
    icon: 'desygner-icon-image',
    cls: 'double',
    isDropdown: true,
    forMobile: true,
    forBoxImage: true,
    type: 'toggle'
  },
  IMAGE_FILTER: {
    action: 'on_imageFilter',
    iconSvg: 'color-filter---20',
    cls: 'double has-left-dividing-line',
    isDropdown: true,
    forBoxWithImage: true,
    hasDropdownTitle: true,
    type: 'toggle'
  },
  IMAGE_BG_REMOVAL: {
    action: 'on_bgRemoval',
    isDropdown: true,
    hasDropdownTitle: true,
    iconSvg: 'remove-background---20',
    cls: 'double',
    type: 'toggle',
    forBoxWithImage: true,
    hide: () =>
      !INKIVE.C.FEATURE_FLAG?.brand_assets?.includes('background_remover')
  },
  SET_BACKGROUND: {
    action: 'on_setBackground',
    isDropdown: true,
    hasDropdownTitle: true,
    iconSvg: 'background---20',
    cls: 'quadra',
    notSubelement: true
  },
  // -----------------------------------------------------------------------------------------------------------------
  // Background
  BACKGROUND_REMOVE: {
    action: 'on_removeElement',
    iconSvg: 'trash---20',
    notSubelement: true,
    hide: function (elem) {
      return elem.attr('fill') === 'none';
    }
  },
  BACKGROUND_COLOR: {
    action: 'colormap-circle',
    icon: 'desygner-icon-fill',
    cls: 'quadra',
    type: 'background',
    isDropdown: true,
    dropdownWidth: '242px',
    hide: function (elem) {
      return INKIVE.PopupMenuDefault.prototype.isBackgroundImage(elem);
    }
  },
  BACKGROUND_COLOR_IMAGE: {
    action: 'colormap-circle',
    icon: 'desygner-icon-fill',
    cls: 'quadra',
    type: 'background',
    isDropdown: true,
    dropdownWidth: '242px',
    hide: function (elem) {
      return !INKIVE.PopupMenuDefault.prototype.isBackgroundImage(elem);
    },
    tooltip: function () {
      const opacity = $('g.background').find('image').attr('opacity');

      const backgroundColorImageTooltip = (!opacity || opacity === 1)
        ? 'popupmenu.tooltip.background_color_image_change'
        : 'popupmenu.tooltip.background_color_image_set';

      return INKIVE.TranslateHelper.translate(backgroundColorImageTooltip);
    }
  },
  BACKGROUND_OPACITY: {
    action: 'on_opacity',
    icon: 'desygner-icon-opacity',
    isDropdown: true,
    dropdownWidth: '230px',
    notSubelement: true,
    hide: function (elem) {
      return !INKIVE.PopupMenuDefault.prototype.isBackgroundImage(elem);
    }
  },
  BACKGROUND_REPOSITION: {
    action: 'on_backgroundReposition',
    icon: 'desygner-icon-reposition',
    cls: 'double',
    isDropdown: true,
    hasDropdownTitle: true,
    type: 'toggle',
    forBoxWithImage: true,
    hide: function (elem) {
      return !INKIVE.PopupMenuDefault.prototype.isBackgroundImage(elem);
    }
  },
  BACKGROUND_FILTER: {
    action: 'on_backgroundFilter',
    iconSvg: 'color-filter---20',
    cls: 'double has-left-dividing-line',
    isDropdown: true,
    forBoxWithImage: true,
    type: 'toggle',
    hasDropdownTitle: true,
    hide: function ($image) {
      const url = $image[0].getAttribute('xlink:href');
      const mimeType = INKIVE.Helpers.isDataURL(url)
        ? getMimeTypeFromDataUrl(url)
        : INKIVE.ImagesFactory.getMimeType(url);
      return $.browser.name === 'msie' || !['image/jpeg', 'image/png'].includes(mimeType);
    }
  },
  BACKGROUND_BG_REMOVAL: {
    action: 'on_bgRemoval',
    hasDropdownTitle: true,
    iconSvg: 'remove-background---20',
    cls: 'double',
    isDropdown: true,
    type: 'toggle',
    forBoxWithImage: true,
    hide: function (elem) {
      let hide = !INKIVE.PopupMenuDefault.prototype.isBackgroundImage(elem);
      if (INKIVE.RestrictionsFacade.initialized) {
        const restrictions = INKIVE.RestrictionsFacade.getAllElementPermissions('background')[0];
        hide = !restrictions?.basic?.image || restrictions?.images;
      }

      if (hide) return hide;

      return (
        INKIVE.C.FEATURE_FLAG &&
        !INKIVE.C.FEATURE_FLAG.brand_assets.includes('background_remover')
      );
    }
  },
  // -----------------------------------------------------------------------------------------------------------------
  // Sticker
  EXPLODE_STICKER: {
    action: 'on_explode_sticker',
    icon: 'desygner-icon-unlink',
    on: 'click',
    hide: function () {
      const selectedElement = (INKIVE.DesignFacade.canvas.getSelectedElems() ||
        [])[0];
      if (!selectedElement) return true;

      const element = INKIVE.DesignFacade.get(selectedElement);

      return (
        element.type !== 'sticker' ||
        !element.banner ||
        !element.texts ||
        !Object.entries(element.texts).length
      );
    }
  },

  // -----------------------------------------------------------------------------------------------------------------
  // Layout
  LAYOUT_CONFIRM: {
    action: 'on_layoutConfirm',
    iconSvg: 'done---20',
    cls: 'double',
    isDropdown: true,
    type: 'toggle',
    hasDropdownTitle: true
  },
  LAYOUT_CLOSE: {
    action: 'on_layoutClose',
    iconSvg: 'cancel---20',
    cls: 'double',
    isDropdown: true,
    type: 'toggle',
    hasDropdownTitle: true,
    hide: function () {
      return $('#svgcontent').is('.order-print-active');
    }
  },

  // -----------------------------------------------------------------------------------------------------------------
  // Text
  TEXT_FONTFAMILY: {
    action: 'on_fontfamily',
    hasDropdownTitle: true,
    cls: 'combo fontfamily',
    type: 'toggle',
    dropdownWidth: '280px',
    isDropdown: true,
    isDropdownList: true,
    fullscreenDropdown: true
  },
  TEXT_FONTSIZE: {
    action: 'on_fontsize',
    hasDropdownTitle: true,
    cls: 'combo fontsize',
    type: 'toggle',
    isDropdown: true,
    isDropdownList: true,
    dropdownHeight: '300px',
    dropdownWidth: '85px'
  },
  TEXT_HEADING: {
    action: 'on_heading',
    hasDropdownTitle: true,
    cls: 'combo heading',
    type: 'toggle',
    isDropdown: true,
    isDropdownList: true,
    dropdownHeight: '235px',
    dropdownWidth: '105px',
    hide: function () {
      const isHeaderAndFooterEnabled = [
        headerAndFooter.main.layer,
        headerAndFooter.header.layer,
        headerAndFooter.footer.layer
      ].includes(INKIVE.DesignFacade.canvas.getCurrentLayerName());
      return isHeaderAndFooterEnabled;
    }
  },
  TEXT_TYPING: {
    action: 'on_textTyping',
    iconSvg: 'typewriter---20',
    cls: 'double',
    isDropdown: true,
    type: 'toggle'
  },
  REMOVE_STYLE: {
    action: 'on_removePartialStyle',
    iconSvg: 'remove-partial---20',
    cls: 'double',
    isDropdown: false,
    type: 'toggle',
    hide: function (elem) {
      const textAttr = new INKIVE.Text.Textarea().setDOM(elem.get(0));
      return textAttr.text.styles.length === 0;
    }
  },
  TEXT_EDITING: {
    action: 'on_textEditing',
    icon: 'desygner-icon-text-edit',
    cls: 'double',
    isDropdown: true,
    type: 'toggle'
  },
  TEXT_FINISH_EDITING: {
    action: 'on_finishTextEditing',
    icon: 'desygner-icon-check',
    cls: 'double',
    isDropdown: true,
    type: 'toggle'
  },
  PARAGRAPH_SPACING: {
    action: 'on_paragraph-spacing',
    iconSvg: 'line-height---20',
    notSubelement: true,
    isDropdown: true,
    dropdownWidth: '210px',
    dropdownContent: {
      TEXT_PARAGRAPH_SPACING: { action: 'on_set-paragraph-spacing-dy' },
      TEXT_LINE_SPACING: { action: 'on_set-paragraph-dy' },
      TEXT_CHAR_SPACING: { action: 'on_set-paragraph-char-spacing' },
      TEXT_FIRST_LINE_MARGIN: { action: 'on_set-paragraph-first-line-margin' },
      TEXT_LINE_MARGIN: { action: 'on_set-paragraph-margin' },
      TEXT_RIGHT_MARGIN: { action: 'on_set-paragraph-right-margin' }
    }
  },
  TEXT_SPACING: {
    action: 'on_text-spacing',
    iconSvg: 'line-height---20',
    notSubelement: true,
    isDropdown: true,
    dropdownWidth: '210px',
    dropdownContent: {
      TEXT_PARAGRAPH_SPACING: { action: 'on_set-paragraph-spacing' },
      TEXT_LINE_SPACING: { action: 'on_set-line-spacing' },
      TEXT_WORD_SPACING: { action: 'on_set-word-spacing' },
      TEXT_CHAR_SPACING: { action: 'on_set-char-spacing' },
      TEXT_FIRST_LINE_MARGIN: { action: 'on_set-first-line-margin' },
      TEXT_LINE_MARGIN: { action: 'on_set-line-margin' },
      TEXT_RIGHT_MARGIN: { action: 'on_set-right-margin' }
    }
  },
  TEXT_BULLETS: {
    action: 'on_set-bullets',
    iconSvg: 'text-ul---20',
    notSubelement: true,
    isDropdown: true,
    dropdownWidth: '296px'
  },
  TEXT_LIST: {
    action: 'on_set-list',
    iconSvg: 'text-ol---20',
    tooltip: () => INKIVE.TranslateHelper.translate('popupmenu.tooltip.text_list'),
    notSubelement: true,
    isDropdown: true,
    dropdownWidth: '296px'
  },
  TEXT_LINK: {
    action: 'on_set-link',
    icon: 'desygner-icon-link',
    cls: 'editor-add-link-to-text',
    forBoxWithImage: true,
    isDropdown: true,
    dropdownWidth: '300px',
    notSubelement: true
  },
  TEXT_AUTO_ADJUSTABLE: {
    action: 'on_set-auto-adjustable',
    icon: 'desygner-icon-auto-adjust',
    hide: function () {
      // Temporarily hiding the auto-adjustable button until we fix associated bugs (see EDIT-960)
      return true;
    }
  },

  TEXT_BOLD: {
    action: 'on_set-bold',
    iconSvg: 'font-bold---20'
  },
  TEXT_ITALIC: {
    action: 'on_set-italic',
    iconSvg: 'font-italic---20'
  },
  TEXT_UNDERLINE: {
    action: 'on_set-underline',
    iconSvg: 'text-underline---20'
  },
  TEXT_CONVERT_DX: {
    action: 'on_convert-dx',
    icon: 'fa fa-repeat',
    tooltip: () =>
      INKIVE.TranslateHelper.translate('popupmenu.tooltip.text_convert_dx')
  },
  TEXT_CASE: {
    action: 'on_text-case',
    iconSvg: 'text-transform---20',
    isDropdown: true,
    isHorizontal: true,
    isMultipleDropdown: true,
    dropdownContent: {
      TEXT_UCASE: {
        action: 'on_set-ucase',
        icon: 'desygner-icon-text-upper-case'
      },
      TEXT_LCASE: {
        action: 'on_set-lcase',
        icon: 'desygner-icon-text-lower-case'
      }
    }
  },

  TEXT_ALIGN: {
    action: 'on_text-align',
    iconSvg: 'text---align-left',
    cls: 'alignment',
    isDropdown: true,
    isHorizontal: true,
    notSubelement: true,
    isMultipleDropdown: true,
    dropdownContent: {
      TEXT_ALIGN_LEFT: {
        action: 'on_set-align-left',
        iconSvg: 'text---align-left'
      },
      TEXT_ALIGN_CENTER: {
        action: 'on_set-align-center',
        iconSvg: 'text---align-center'
      },
      TEXT_ALIGN_RIGHT: {
        action: 'on_set-align-right',
        iconSvg: 'text---align-right'
      },
      TEXT_ALIGN_JUSTIFY_ALL: {
        action: 'on_set-align-justify_all',
        iconSvg: 'text---align-justify-all'
      },
      TEXT_ALIGN_JUSTIFY_START: {
        action: 'on_set-align-justify_start',
        iconSvg: 'text---align-justify-start'
      },
      TEXT_ALIGN_JUSTIFY_MIDDLE: {
        action: 'on_set-align-justify_middle',
        iconSvg: 'text---align-justify-middle'
      },
      TEXT_ALIGN_JUSTIFY_END: {
        action: 'on_set-align-justify_end',
        iconSvg: 'text---align-justify-end'
      }
    }
  },

  TEXT_COLUMNS: {
    action: 'on_text-column',
    iconSvg: 'columns',
    notSubelement: true,
    isDropdown: true,
    dropdownWidth: '210px',
    dropdownContent: {
      TEXT_COLUMNS_NUMBER: { action: 'on_set-column-number' },
      TEXT_COLUMNS_WIDTH: { action: 'on_set-column-width' },
      TEXT_COLUMNS_GAP: { action: 'on_set-column-gap' }
    }
  },

  TEXT_COLOR: {
    action: 'colormap-circle',
    iconSvg: 'text-color---20',
    cls: 'quadra',
    type: 'fill',
    isDropdown: true,
    dropdownWidth: '242px'
  },
  // Table
  CELL_TEXT_TYPING: {
    action: 'on_cell-text-typing',
    iconSvg: 'typewriter---20',
    cls: 'double',
    isDropdown: true,
    type: 'toggle',
    hide: function () {
      const tableElement = INKIVE.Table?.tableSelectionInstance?.tableElement;
      if (!tableElement) return true;

      const selectedCells = INKIVE.Table.tableSelectionInstance.getSelectedCellElements();
      if (selectedCells.length > 1) return true;

      return false;
    }
  },
  CELL_SELECT_ALL: {
    action: 'on_select-all-cells',
    icon: 'table-icon-select-all',
    tooltip: () =>
      INKIVE.TranslateHelper.translate('editor.contextmenu.select_all_cells'),
    hide: function () {
      return !INKIVE.Table.tableSelectionInstance;
    }
  },
  CELL_INVERT_SELECTION: {
    action: 'on_invert-cell-selection',
    icon: 'table-icon-invert-selection',
    tooltip: () =>
      INKIVE.TranslateHelper.translate(
        'editor.contextmenu.invert_cell_selection'
      ),
    hide: function () {
      return !INKIVE.Table.tableSelectionInstance;
    }
  },
  CELL_COLOR: {
    action: 'colormap-circle',
    iconSvg: 'text-color---20',
    icon: 'desygner-icon-fill',
    type: 'cell_foreground',
    isDropdown: true,
    dropdownWidth: '242px',
    tooltip: () => INKIVE.TranslateHelper.translate('editor.contextmenu.cell_foreground_color')
  },
  CELL_BACKGROUND: {
    action: 'colormap-circle',
    icon: 'desygner-icon-fill',
    cls: 'quadra',
    type: 'cell_background',
    isDropdown: true,
    dropdownWidth: '242px',
    tooltip: () => INKIVE.TranslateHelper.translate('editor.contextmenu.cell_background_color')
  },
  CELL_BOLD: {
    action: 'on_cell-bold',
    iconSvg: 'font-bold---20',
    tooltip: () => INKIVE.TranslateHelper.translate('editor.contextmenu.toggle_cell_bold')
  },
  CELL_ITALIC: {
    action: 'on_cell-italic',
    iconSvg: 'font-italic---20',
    tooltip: () => INKIVE.TranslateHelper.translate('editor.contextmenu.toggle_cell_italic')
  },
  CELL_UNDERLINE: {
    action: 'on_cell-underline',
    iconSvg: 'text-underline---20'
  },
  CELL_HIGHLIGHT: {
    action: 'colormap-circle',
    iconSvg: 'text-highlight---20',
    cls: 'quadra',
    type: 'cell_highlight',
    isDropdown: true,
    dropdownWidth: '242px'
  },
  CELL_LIST: {
    action: 'on_cell-list',
    iconSvg: 'text-ol---20',
    cls: 'orderedList',
    tooltip: () => INKIVE.TranslateHelper.translate('popupmenu.tooltip.text_list')
  },
  CELL_BULLETS: {
    action: 'on_cell-bullets',
    iconSvg: 'text-ul---20',
    tooltip: () => INKIVE.TranslateHelper.translate('popupmenu.tooltip.text_bullets')
  },
  CELL_EDIT_ALIGNMENT: {
    action: 'on_edit-cell-alignment',
    iconSvg: 'cell-align---20',
    isDropdown: true,
    dropdownWidth: '134px',
    tooltip: () => INKIVE.TranslateHelper.translate('editor.contextmenu.edit_cell_alignment')
  },
  CELL_TEXT_ALIGNMENT: {
    action: 'on_text-align',
    iconSvg: 'text---align-left',
    cls: 'alignment',
    isDropdown: true,
    isHorizontal: true,
    notSubelement: true,
    isMultipleDropdown: true,
    dropdownContent: {
      TEXT_ALIGN_LEFT: {
        action: 'on_set-align-left',
        iconSvg: 'text---align-left'
      },
      TEXT_ALIGN_CENTER: {
        action: 'on_set-align-center',
        iconSvg: 'text---align-center'
      },
      TEXT_ALIGN_RIGHT: {
        action: 'on_set-align-right',
        iconSvg: 'text---align-right'
      },
      TEXT_ALIGN_JUSTIFY_ALL: {
        action: 'on_set-align-justify_all',
        iconSvg: 'text---align-justify-all'
      },
      TEXT_ALIGN_JUSTIFY_START: {
        action: 'on_set-align-justify_start',
        iconSvg: 'text---align-justify-start'
      },
      TEXT_ALIGN_JUSTIFY_MIDDLE: {
        action: 'on_set-align-justify_middle',
        iconSvg: 'text---align-justify-middle'
      },
      TEXT_ALIGN_JUSTIFY_END: {
        action: 'on_set-align-justify_end',
        iconSvg: 'text---align-justify-end'
      }
    }
  },
  CELL_EDIT_BORDER: {
    action: 'on_edit-cell-border',
    hasDropdownTitle: true,
    dropdownTitle: 'Border',
    iconSvg: 'border---20',
    isDropdown: true,
    dropdownWidth: '215px',
    tooltip: () => INKIVE.TranslateHelper.translate('editor.contextmenu.edit_cell_border')
  },
  TABLE_ROWS_AND_COLUMNS: {
    action: 'on_edit-rows-and-columns',
    iconSvg: 'rows-and-columns---20',
    hasDropdownTitle: true,
    dropdownTitle: 'Rows and Columns',
    isDropdown: true,
    dropdownWidth: '240px',
    isHorizontal: true,
    isMultipleDropdown: true,
    dropdownContent: {
      ROW_INSERT_BEFORE: {
        action: 'on_insert-row-before',
        iconSvg: 'insert-row-before'
      },
      ROW_INSERT_AFTER: {
        action: 'on_insert-row-after',
        iconSvg: 'insert-row-after'
      },
      ROW_DELETE: {
        action: 'on_delete-row',
        iconSvg: 'delete-row'
      },
      COLUMN_INSERT_BEFORE: {
        action: 'on_insert-column-before',
        iconSvg: 'insert-column-before'
      },
      COLUMN_INSERT_AFTER: {
        action: 'on_insert-column-after',
        iconSvg: 'insert-column-after'
      },
      COLUMN_DELETE: {
        action: 'on_delete-column',
        iconSvg: 'delete-column'
      }
    },
    tooltip: () => 'Rows and Columns' // TODO: add translation
  },
  CELL_FONT_FAMILY: {
    action: 'on_fontfamily',
    hasDropdownTitle: true,
    cls: 'combo fontfamily',
    type: 'toggle',
    dropdownWidth: '280px',
    isDropdown: true,
    isDropdownList: true,
    fullscreenDropdown: true
  },
  CELL_FONT_SIZE: {
    action: 'on_fontsize',
    hasDropdownTitle: true,
    cls: 'combo fontsize',
    type: 'toggle',
    isDropdown: true,
    isDropdownList: true,
    dropdownHeight: '300px',
    dropdownWidth: '85px'
  },
  CELL_BORDER_COLOR: {
    action: 'colormap-circle',
    icon: 'desygner-icon-fill',
    cls: 'quadra',
    type: 'cell_lines',
    isDropdown: true,
    dropdownWidth: '242px',
    tooltip: () =>
      INKIVE.TranslateHelper.translate('editor.contextmenu.cell_border_color'),
    hide: function () {
      return (
        !INKIVE.Table.tableSelectionInstance ||
        !INKIVE.Table.tableSelectionInstance.getSelectedCellElements().length
      );
    }
  },
  CELL_SPACING: {
    action: 'on_cell-spacing',
    iconSvg: 'line-height---20',
    notSubelement: true,
    isDropdown: true,
    dropdownWidth: '222px',
    dropdownContent: {
      TEXT_PARAGRAPH_SPACING: { action: 'on_set-cell-paragraph-spacing' },
      TEXT_LINE_SPACING: { action: 'on_set-cell-line-spacing' },
      TEXT_WORD_SPACING: { action: 'on_set-cell-word-spacing' },
      TEXT_CHAR_SPACING: { action: 'on_set-cell-letter-spacing' },
      TEXT_FIRST_LINE_MARGIN: { action: 'on_set-cell-first-line-margin' },
      TEXT_LINE_MARGIN: { action: 'on_set-cell-line-margin' },
      TEXT_RIGHT_MARGIN: { action: 'on_set-cell-right-margin' }
    }
  },
  CELL_FONT: {
    action: 'on_edit-cell-font',
    icon: 'table-icon-cell-font',
    isDropdown: true,
    dropdownWidth: '240px',
    tooltip: () =>
      INKIVE.TranslateHelper.translate('editor.contextmenu.edit_cell_font'),
    hide: function () {
      return (
        !INKIVE.Table.tableSelectionInstance ||
        !INKIVE.Table.tableSelectionInstance.getSelectedCellElements().length
      );
    }
  },
  CELL_CASE: {
    action: 'on_cell-case',
    iconSvg: 'text-transform---20'
  },
  CELL_MERGE: {
    action: 'on_merge-cells',
    icon: 'table-icon-cell-merge',
    tooltip: () =>
      INKIVE.TranslateHelper.translate('editor.contextmenu.merge_cells'),
    hide: function () {
      return !INKIVE.Table.canMerge();
    }
  },
  CELL_SPLIT: {
    action: 'on_split-cell',
    icon: 'table-icon-cell-split',
    tooltip: () =>
      INKIVE.TranslateHelper.translate('editor.contextmenu.split_cell'),
    hide: function () {
      return !INKIVE.Table.canSplit();
    }
  },
  ROW_INSERT_BEFORE: {
    action: 'on_insert-row-before',
    icon: 'table-icon-insert-row-before',
    tooltip: () => INKIVE.TranslateHelper.translate('editor.contextmenu.insert_row_before')
  },
  ROW_INSERT_AFTER: {
    action: 'on_insert-row-after',
    icon: 'table-icon-insert-row-after',
    tooltip: () => INKIVE.TranslateHelper.translate('editor.contextmenu.insert_row_after')
  },
  COLUMN_INSERT_BEFORE: {
    action: 'on_insert-column-before',
    icon: 'table-icon-insert-column-before',
    tooltip: () => INKIVE.TranslateHelper.translate('editor.contextmenu.insert_column_before')
  },
  COLUMN_INSERT_AFTER: {
    action: 'on_insert-column-after',
    icon: 'table-icon-insert-column-after',
    tooltip: () => INKIVE.TranslateHelper.translate('editor.contextmenu.insert_column_after')
  },
  ROW_DELETE: {
    action: 'on_delete-row',
    icon: 'table-icon-delete-row',
    tooltip: () => INKIVE.TranslateHelper.translate('editor.contextmenu.delete_row')
  },
  COLUMN_DELETE: {
    action: 'on_delete-column',
    icon: 'table-icon-delete-column',
    tooltip: () => INKIVE.TranslateHelper.translate('editor.contextmenu.delete_column')
  },
  // Group/ungroup
  GROUP_GROUP: {
    action: 'on_groupGroup',
    iconSvg: 'group---20',
    hasDropdownTitle: true,
    cls: 'double',
    isDropdown: true,
    type: 'toggle',
    hide: function () {
      const selectedItems = INKIVE.EditorFacade.canvas.getSelectedElems();
      return selectedItems.length < 2;
    }
  },

  CONVERT_IMAGEBOX: {
    action: 'on_groupGroup',
    isDropdown: true,
    cls: 'double'
  },

  GROUP_UNGROUP: {
    action: 'on_groupUngroup',
    iconSvg: 'ungroup---20',
    hasDropdownTitle: true,
    notLocked: true,
    cls: 'double',
    isDropdown: true,
    type: 'toggle'
  },

  // Lock/unlock
  LOCK: {
    action: 'on_lockElement',
    iconSvg: 'unlock---20',
    notSubelement: true,
    notLocked: true,
    cls: 'has-right-dividing-line'
  },

  UNLOCK: {
    action: 'on_unlockElement',
    iconSvg: 'lock---20',
    notSubelement: true,
    isLocked: true,
    cls: 'double unlock has-right-dividing-line',
    isDropdown: true,
    type: 'toggle'
  },

  PERMISSIONS: {
    action: 'on_set_permissions',
    notSubelement: true,
    hasDropdownTitle: true,
    isDropdown: true,
    iconSvg: 'restrict---20',
    cls: 'no-icon',
    hide: () => {
      return INKIVE.Menus.showSimplifiedRestrictions;
    }
  },

  DESELECT: {
    action: 'on_deselect',
    notSubelement: true,
    icon: 'desygner-icon-deselect'
  },

  CONVERT_TO_IMAGE_BOX: {
    action: 'on_deselect',
    notSubelement: true,
    icon: 'desygner-icon-deselect'
  },

  LIBRARY_ADD: {
    action: 'on_library_add',
    notSubelement: true,
    hasDropdownTitle: true,
    cls: 'has-right-dividing-line',
    iconSvg: 'briefcase---20',
    isDropdown: true,
    tooltip: function () {
      const addToLibraryTooltip =
        INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESIGN &&
        !INKIVE.PopupMenuDefault.canAccessWorkspaceLibrary
          ? 'editor.contextmenu.add_to_personal_library'
          : 'editor.contextmenu.add_to_brand_assets';

      return INKIVE.TranslateHelper.translate(addToLibraryTooltip);
    },
    hide: function () {
      return (
        !INKIVE.PopupMenuDefault.prototype.isAddtoLibraryAvailable(true) &&
        !INKIVE.PopupMenuDefault.canAccessWorkspaceLibrary
      );
    }
  },

  LIBRARY_ADD_QUIET: {
    action: 'on_library_add_quiet',
    hasDropdownTitle: true,
    isDropdown: true,
    notSubelement: true,
    iconSvg: 'briefcase---20',
    tooltip: function () {
      const addToLibraryTooltip =
        INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESIGN
          ? 'editor.contextmenu.add_to_personal_library'
          : 'editor.contextmenu.add_to_brand_assets';

      return INKIVE.TranslateHelper.translate(addToLibraryTooltip);
    },
    hide: function () {
      return (
        !INKIVE.PopupMenuDefault.prototype.isAddtoLibraryAvailable(false) ||
        INKIVE.PopupMenuDefault.canAccessWorkspaceLibrary
      );
    }
  },

  ANIMATE: {
    action: 'on_animate',
    notSubelement: true,
    hasDropdownTitle: true,
    isDropdown: true,
    iconSvg: 'animate---20',
    dropdownTitle: INKIVE.TranslateHelper.translate('editor.contextmenu.animate'),
    tooltip: function () {
      const tooltipName = 'editor.contextmenu.animate';
      return INKIVE.TranslateHelper.translate(tooltipName);
    },
    hide: function () {
      const shouldShowAnimation = INKIVE.C.SHOW_ANIMATION &&
        INKIVE.RestrictionsFacade.isFunctionalityAllowed('function_animation_file');
      return !shouldShowAnimation;
    }
  },

  DETACH_SMART_ASSET: {
    action: 'on_unlink_smart_asset',
    isDropdown: true,
    hasDropdownTitle: true,
    notSubelement: true,
    iconSvg: 'unlink-smart-asset',
    dropdownTitle: INKIVE.TranslateHelper.translate('editor.contextmenu.detach_smart_asset'),
    cls: 'unlink-smart-asset',
    tooltip: function () {
      const tooltipName = 'editor.contextmenu.detach_smart_asset';
      return INKIVE.TranslateHelper.translate(tooltipName);
    },
    hide: function () {
      const [selectedElement] = [
        ...(INKIVE.DesignFacade.canvas.getSelectedElems() || [])
      ];
      if (!selectedElement) return true;

      return !selectedElement.hasAttribute(
        config.smartAssets.attributes.definedAsset
      ) || INKIVE.C.BOOK.book_type !== INKIVE.C.BOOK_TYPE.TEMPLATE;
    }
  },

  // Link
  LINK: {
    action: 'on_linkElement',
    iconSvg: 'link---20',
    cls: 'editor-add-link-to-text',
    notSubelement: true,
    isDropdown: true,
    dropdownWidth: '300px',
    notLinked: true
  },

  UNLINK: {
    action: 'on_unlinkElement',
    icon: 'desygner-icon-unlink',
    cls: 'editor-remove-link-to-text',
    isDropdown: true,
    dropdownWidth: '300px',
    notSubelement: true,
    isLinked: true
  },

  // Video
  VIDEO_SOURCE: {
    action: 'on_set-source',
    icon: 'fa fa-film',
    notSubelement: true
  },
  VIDEO_AUTOPLAY: {
    action: 'on_toggle-autoplay',
    iconSvg: 'play---20',
    notSubelement: true,
    toggle: 'autoplay',
    cls: 'has-right-dividing-line'
  },
  VIDEO_MOVE_TO_NEXT: {
    action: 'on_toggle-move-to-next',
    iconSvg: 'fast-forward---20',
    notSubelement: true,
    toggle: 'movetonext'
  },
  VIDEO_MUTE: {
    action: 'on_toggle-mute',
    iconSvg: 'volume---20',
    notSubelement: true,
    toggle: function (data) {
      return !data.mute;
    }
  },
  VIDEO_CONTROLS: {
    action: 'on_toggle-controls',
    iconSvg: 'sliders---20',
    notSubelement: true,
    toggle: 'controls'
  },
  VIDEO_FULLSCREEN: {
    action: 'on_toggle-fullscreen',
    iconSvg: 'expand---20',
    notSubelement: true,
    toggle: 'fullscreen'
  },
  VIDEO_LOOP: {
    action: 'on_toggle-loop',
    iconSvg: 'refresh---20',
    notSubelement: true,
    toggle: 'loop',
    cls: 'has-right-dividing-line'
  },

  RESTRICTION_INFO: {
    action: 'on_restrictionInfo',
    icon: 'desygner-icon-question-mark'
  },

  ROOT_DRAWING: {
    action: 'on_rootDrawing',
    hasDropdownTitle: true,
    isDropdown: true,
    iconSvg: 'drawing---20',
    cls: 'root-icons',
    dropdownWidth: '260px',
    dropdownContent: function ($el) {
      INKIVE.Menus.elementPopupMenu.popupMenuButtons.popupMenuCommonFunctions.getDrawingButtons(
        $el
      );
    }
  },

  ROOT_SHAPES: {
    action: 'on_rootShapes',
    hasDropdownTitle: true,
    isDropdown: true,
    cls: 'root-icons',
    iconSvg: 'geometrical-shapes---20',
    dropdownWidth: '280px',
    dropdownHeight: '500px',
    dropdownContent: function ($el) {
      INKIVE.Menus.elementPopupMenu.popupMenuButtons.popupMenuCommonFunctions.getShapeButtons(
        $el
      );
    }
  },

  ROOT_FRAMES: {
    action: 'on_rootFrames',
    hasDropdownTitle: true,
    isDropdown: true,
    cls: 'root-icons',
    iconSvg: 'frames---20',
    dropdownWidth: '330px',
    dropdownHeight: '500px',
    dropdownContent: function ($el) {
      INKIVE.Menus.elementPopupMenu.popupMenuButtons.popupMenuCommonFunctions.getFrameButtons(
        $el
      );
    }
  },

  ROOT_TEXT: {
    action: 'on_rootText',
    hasDropdownTitle: true,
    isDropdown: true,
    cls: 'root-icons',
    iconSvg: 'text---20',
    dropdownWidth: '280px',
    dropdownHeight: '190px',
    dropdownContent: function ($el) {
      INKIVE.Menus.elementPopupMenu.popupMenuButtons.popupMenuCommonFunctions.getTextButtons(
        $el
      );
    }
  },

  ROOT_TABLE: {
    action: 'on_rootTable',
    hasDropdownTitle: true,
    isDropdown: true,
    cls: 'root-icons',
    iconSvg: 'table---20',
    dropdownWidth: '216px',
    dropdownHeight: '248px',
    dropdownContent: function ($el) {
      INKIVE.Menus.elementPopupMenu.popupMenuButtons.popupMenuCommonFunctions.getTableButtons(
        $el
      );
    }
  },

  BLEED_SIZE: {
    action: 'on_bleedsize',
    titleTag: true,
    cls: 'combo',
    type: 'toggle',
    isDropdown: true,
    isDropdownList: true,
    dropdownWidth: '85px'
  },

  BLEED_CLOSE: {
    hasDropdownTitle: true,
    isDropdown: true,
    action: 'on_bleedClose',
    notSubelement: true,
    iconSvg: 'cross',
    dropdownTitle: INKIVE.TranslateHelper.translate('popupmenu.dropdown_title.bleed_close'),
    cls: 'has-right-dividing-line'
  },

  HEADER_AND_FOOTER_CLOSE: {
    hasDropdownTitle: true,
    isDropdown: true,
    action: 'on_HeaderAndFooterClose',
    notSubelement: true,
    iconSvg: 'cross',
    cls: 'has-right-dividing-line'
  },

  HEADER_AND_FOOTER_PAGE_SETTINGS: {
    action: 'on_HeaderAndFooterPageSettings',
    notSubelement: true,
    iconSvg: 'page-settings',
    hasDropdownTitle: true,
    isDropdown: true,
    modalDropdown: true,
    dropdownTitle: INKIVE.TranslateHelper.translate('popupmenu.header_and_footer.title.settings'),
    tooltip: () => INKIVE.TranslateHelper.translate('popupmenu.header_and_footer.title.settings')
  },

  RESTRICT_CHANGES: {
    action: 'on_restrict_changes',
    notSubelement: true,
    iconSvg: 'restrict---20',
    dropdownTitle: INKIVE.TranslateHelper.translate('popupmenu.tooltip.restrict_changes'),
    tooltip: () => INKIVE.TranslateHelper.translate('popupmenu.tooltip.restrict_changes'),
    hide: (elem) => {
      if (!elem || !elem.length) return true;
      return !INKIVE.Menus.showSimplifiedRestrictions;
    }
  }

};

export default PopupMenuDefault;
